class Provider {
  configApi;
  token;
  constructor(config, token) {
    this.configApi = config;
    this.token = token;
  }
}

export { Provider };
//# sourceMappingURL=provider.esm.js.map
